import { render, staticRenderFns } from "./report_subsidiary.vue?vue&type=template&id=674068aa&"
import script from "./report_subsidiary.vue?vue&type=script&lang=js&"
export * from "./report_subsidiary.vue?vue&type=script&lang=js&"
import style0 from "./report_subsidiary.vue?vue&type=style&index=0&id=674068aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports